import { createCrudSagas } from './CrudSagas'
import { RecordingsActions } from '../reducers/RecordingsRedux'

const crudSagas = createCrudSagas('recordings', RecordingsActions)

export const findRecordings = crudSagas.findRecordings
export const getRecording = crudSagas.getRecording
export const createRecording = crudSagas.createRecording
export const updateRecording = crudSagas.updateRecording
